import assets from 'assets';

export const filters = [
  {
    id: 100,
    name: 'No Filter',
    descrption: '',
    image_url: assets.noFilter,
  },
  {
    id: 1,
    name: 'Vivid Colors',
    descrption:
      "Apply a 'Vivid Colors' filter to saturate the image with intense and lively hues that captivate the eye.",
    image_url:
      'https://static.tryleap.ai/image-gen-043758cb-bacb-42dc-a27e-30a1f44fc051/generated_images/0.png',
  },
  {
    id: 2,
    name: 'Monochromatic Palette',
    descrption:
      "Transform the scene using a 'Monochromatic Palette' filter, highlighting the scene's details through a single color tone.",
    image_url:
      'https://static.tryleap.ai/image-gen-064a9044-f53b-421d-a051-718d3a56107d/generated_images/0.png',
  },
  {
    id: 3,
    name: 'Soft Pastels',
    descrption:
      "Infuse a 'Soft Pastels' filter into the image, giving it a gentle and dreamlike quality with delicate, light shades.",
    image_url:
      'https://static.tryleap.ai/image-gen-qqd4dutbfwt3zq6cybfgk45pyy/generated_images/3c4fb8f2-cc84-4668-b0fd-8cc37ebec1ee-0.png',
  },
  {
    id: 4,
    name: 'High Contrast',
    descrption:
      "Apply a 'High Contrast' filter to emphasize bold differences between light and shadow for a striking visual impact.",
    image_url:
      'https://static.tryleap.ai/image-gen-j75vihdb7hexiexr4kmjjtbq7q/generated_images/601c5b4f-778c-485b-b8dd-8f422ae4265f-1.png',
  },
  {
    id: 5,
    name: 'Muted Tones',
    descrption:
      "Enhance the tranquility of the image with a 'Muted Tones' filter, creating a calm and serene atmosphere.",
    image_url:
      'https://static.tryleap.ai/image-gen-fbv5sq3bovar2ohct4asf36qte/generated_images/73a06f16-6226-4aaf-a250-3704623df104-0.png',
  },
  {
    id: 6,
    name: 'Dramatic Lighting',
    descrption:
      "Add a 'Dramatic Lighting' filter to create a sense of mystery and tension through contrast.",
    image_url:
      'https://static.tryleap.ai/image-gen-g3p77rlbooyhvs2ilsj5j2atra/generated_images/5293d4da-7b72-4c6d-923d-65e2d9c2da42-0.png',
  },
  {
    id: 7,
    name: 'Watercolor Painting',
    descrption:
      'Transform the image into a watercolor painting, where colors bleed and blend, creating a delicate and artistic effect.',
    image_url:
      'https://static.tryleap.ai/image-gen-nnme2ltbs7zmrfokeshviz2so4/generated_images/de2fe3ec-1fc8-4a43-b1a1-7bc20d10b4a3-0.png',
  },
  {
    id: 8,
    name: 'Rustic Textures',
    descrption:
      "Apply a 'Rustic Textures' filter to add texture and depth, enhancing the cozy and nostalgic ambiance.",
    image_url:
      'https://static.tryleap.ai/image-gen-37fffb32-cc22-4ed4-9b6d-768ee5ad105a/generated_images/0.png',
  },
  {
    id: 9,
    name: 'Vintage Sepia',
    descrption:
      "Give the image a classic touch with a 'Vintage Sepia' filter, evoking memories of old photographs.",
    image_url:
      'https://static.tryleap.ai/image-gen-cxvur4dbuek2i2o3i2wwiukqsy/generated_images/48eb7f08-25a2-4ca0-b645-74da3d626518-3.png',
  },
  {
    id: 10,
    name: 'Dreamy Atmosphere',
    descrption:
      "Infuse a 'Dreamy Atmosphere' filter to make the scene feel soft and ethereal, as if seen through a dream.",
    image_url:
      'https://static.tryleap.ai/image-gen-j2eotelbesn4sn5etplc5x6pty/generated_images/241d8012-2823-4927-8241-a9833a1d51ea-0.png',
  },
  {
    id: 11,
    name: 'Impressionistic Strokes',
    descrption:
      "Apply an 'Impressionistic Strokes' filter to capture the energy and emotion of the moment through dynamic brushwork.",
    image_url:
      'https://static.tryleap.ai/image-gen-m2wuw7lbnkk6brwqckua2kvrs4/generated_images/75a82b20-a0dc-41a4-9c7f-2f784abdfbf0-0.png',
  },
  {
    id: 12,
    name: 'Close-up Details',
    descrption:
      "Use a 'Close-up Details' filter to focus on intricate elements, revealing the beauty in small things.",
    image_url:
      'https://static.tryleap.ai/image-gen-csw3psdbuy5skk3e22dt5e5yju/generated_images/d07672cd-d4b9-437b-9779-3ef0f640f865-0.png',
  },
];
